import { useDispatch, useSelector } from "react-redux";
import AssetNumber from "./AssetNumber";
import AssetNumberValue from 'Store/AssetManagement/AssetNumber/AssetNumberDispatch';
import RequisitionAction from "Store/Component/Requisition/RequisitionAction";
import { useEffect, useState } from "react";
import { CONSTANTS } from "client/utils/constants";
import RequisitionValidation from "../Requisition/RequisitionValidation"
import { setAssetError } from 'Store/AssetManagement/AssetNumber/AssetNumberAction';

const AssetNumberContainer = (props?: any) => {
    const order = props?.order;
    const setOrder = props?.setOrder;
    const setAssetChangeReason = props?.setAssetChangeReason;
    const assetDetailList = props?.assetDetailList;
    const isAssetBtnClicked = props?.isAssetBtnClicked;
    const setIsAssetBtnClicked = props?.setIsAssetBtnClicked;
    const assetChangeReason = props?.assetChangeReason;
    const setIsAsserNumberValid = props?.setIsAsserNumberValid
    const addToCart = props?.addToCart
    const setAddToCart = props?.setAddToCart
    const type = props?.type
    const inputRef = props?.inputRef
    const AssetType = props?.AssetType
    const dispatch = useDispatch();
    const dispatchGetAssetNumber = AssetNumberValue.dispatchGetAssetNumberValue(dispatch);

    const [assetNumberError, setAssetNumbererror] = useState<any>("");
    const [changedIndex, setChangedIndex] = useState<any>();

    const {
        orderDetails,
        assetValidationError,
        assetDetails,
        reasonList,
        selectedBranch,
        transferAssets,
        reactivationAssets,
        requisitionTypeDropdown,
        managedEquipmentList
    }: any = useSelector((state?: any) => ({
        orderDetails: state.TransferReducer.orderDetails,
        assetValidationError: state.AssetNumber.assetError,
        assetDetails: state.AssetNumber.reacivationAssetDetails,
        reasonList: state.RequisitionReducer.reasonList,
        selectedBranch: state.RequisitionReducer.selectedBranch,
        transferAssets: state.TransferReducer.assets,
        reactivationAssets: state.TransferReducer.assets,
        requisitionTypeDropdown: state.AssetManagement.AssetType,
        managedEquipmentList: state.RequisitionReducer.managedEquipmentList,
    }));
    const handleKeyPress = (event: any) => {
        if (event.charCode === 13) {
            handleAssetBtn();
        }
    }

    const handleAssetBtn = () => {
        if (orderDetails?.requestType?.label && (orderDetails?.requestType?.label !== CONSTANTS?.REQUISITION)) {
            setIsAssetBtnClicked(true)
            let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : [];
            const findAsset = assetDetailList?.filter((i: any) => i?.assetNumber == order?.assetNumber);
            if (findAsset?.length > 1) {
                assetDetailListTemp.forEach((assetItem: any) => {
                    if (assetItem.assetIndex === order.assetIndex) {
                        assetItem.assetError = "The Asset you have chosen is already associated with other item in this request. Please enter a new asset number that is not been associated.";
                        return
                    }
                });
                setOrder(assetDetailListTemp);
                return;
            }

            assetDetailListTemp.forEach((assetItem: any) => {
                if (assetItem.assetIndex === order.assetIndex) {
                    assetItem.assetError = "";
                    assetItem.conditionRating = "";
                    assetItem.conditionComment = "";
                    assetItem.estimatedDispositionPrice = "";
                    assetItem.odometerHourMeter = "";
                    assetItem.attachments = [];
                    assetItem.glCategory = "";
                    return
                }
            });
            setOrder(assetDetailListTemp);
        }
        dispatch(RequisitionAction.setIsChangesOccured(true));

        if (!order?.asset && type == CONSTANTS?.REQUISITION) {

            let reasonListTemp = reasonList?.length > 0 ? [...reasonList] : [];
            for (let i = 0; i < reasonListTemp.length; i++) {
                if (reasonListTemp[i]?.reasonIndex === order?.reasonIndex) {
                    if (reasonListTemp[i].asset == order?.assetNumber) {
                        reasonListTemp[i].asset = order?.assetNumber;
                        reasonListTemp[i].unitNumber = "";
                        reasonListTemp[i].description = "";
                        reasonListTemp[i].modelYear = "";
                        reasonListTemp[i].netBookedValue = "";
                        reasonListTemp[i].replacementAssetDisposalDate = "";
                        reasonListTemp[i].isValidAsset = false;
                        reasonListTemp[i].assetError = "Please enter Valid Replaced Asset #";
                    }
                }
            }
            dispatch(RequisitionAction.setIReason(reasonListTemp))
        } else if (!order?.assetNumber && (orderDetails?.requestType?.label && (orderDetails?.requestType?.label !== CONSTANTS?.REQUISITION))) {
            setIsAssetBtnClicked(true)
            let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : [];
            assetDetailListTemp.forEach((assetItem: any) => {
                if (assetItem.assetIndex === order.assetIndex) {
                    assetItem.assetError = "Please enter Valid Asset #";
                    assetItem.unitNumber = "";
                    assetItem.modelYear = "";
                    assetItem.color = "";
                    assetItem.description = "";
                    assetItem.serialNumber = "";
                    assetItem.licensePlateNumber = "";
                    assetItem.monthlyAmount = "";
                    assetItem.monthRemaining = "";
                    assetItem.equipmentClassDesc = "";
                    assetItem.eqStatusDesc = "";
                    assetItem.netBookedValue = "";
                    assetItem.glCategory = "";
                    assetItem.isOdometerRequired = "";
                    assetItem.model = '';
                    assetItem.costCenterNo = '';
                    assetItem.manufacturerName = '';
                    assetItem.dateDisposed = '';
                }
            });
            setOrder(assetDetailListTemp)
        } else if (order?.asset && type == CONSTANTS?.REQUISITION) {
            let reasonListTemp = reasonList?.length > 0 ? [...reasonList] : [];
            for (let i = 0; i < reasonListTemp?.length; i++) {
                if (reasonListTemp[i]?.reasonIndex === order?.reasonIndex) {
                    setAssetChangeReason(order);
                    let ManagedEquipmentSubTypeId: any = 0;
                    const requestType = requisitionTypeDropdown?.find((i: any) => i?.orderRequestType === order?.requestType);
                    if (requestType?.orderRequestType == CONSTANTS.MANAGED_EQUIPMENT) {
                        ManagedEquipmentSubTypeId = managedEquipmentList?.find((item?: any) => item?.requestIndex === reasonListTemp[i]?.requestIndex)
                    }
                    let value = {
                        "assetNumber": order.asset,
                        "costCenterNo": selectedBranch?.label?.split('-')[0]?.trim().toString(),
                        "reasonReplacementId": order.reasonId,
                        "transDispoReactivationAssetDetailId": 0,
                        "requestType": CONSTANTS.REQUISITION,
                        "orderTypeId": requestType?.orderRequestTypeId,
                        "orderSubTypeId": requestType?.orderRequestType == CONSTANTS.MANAGED_EQUIPMENT ? parseInt(ManagedEquipmentSubTypeId?.orderSubTypeId) : requestType?.orderRequestSubTypeId
                    }
                    dispatchGetAssetNumber(value)
                }
            }
        } else {
            setIsAssetBtnClicked(true)
            setChangedIndex(order?.assetIndex)
            let value = {
                "assetNumber": order?.assetNumber,
                "costCenterNo": orderDetails?.selectedBranch?.costCenter.toString(),
                "reasonReplacementId": 0,
                "transDispoReactivationAssetDetailId": order?.transferDispoReactivationAssetDetailId || 0,
                "requestType": orderDetails?.requestType?.label
            }
            dispatchGetAssetNumber(value)
        }
    }
    useEffect(() => {
        if (!order?.assetNumber && !isAssetBtnClicked) {
            dispatch(setAssetError({ assetNumber: "", assetError: "" }))
        }
    }, [order])

    useEffect(() => {
        if (addToCart) {
            if (assetValidationError?.assetError?.length) {
                setIsAsserNumberValid(false)
                setAddToCart(false)
            } else if (!order?.assetNumber) {
                validateAsset(order?.assetNumber)
            } else {
                let assetDetailListTemp = assetDetailList?.length > 0 ? [...assetDetailList] : [];
                const findAsset = assetDetailList?.filter((i: any) => i?.assetNumber == order?.assetNumber);
                if (findAsset?.length > 1) {
                    assetDetailListTemp.forEach(assetItem => {
                        if (assetItem.assetIndex === changedIndex) {
                            assetItem.assetError = "The Asset you have chosen is already associated with other item in this request. Please enter a new asset number that is not been associated.";
                            return
                        }
                    });
                    setOrder(assetDetailListTemp);
                } else {
                    setIsAsserNumberValid(true)
                }
                setAddToCart(false)
            }
        }
    }, [addToCart])
    const validateAsset = (assetNumber: any) => {
        let errorMsg = { assetNumber: "", assetError: "" }
        if (assetNumber === undefined || assetNumber === null || assetNumber === "") {
            errorMsg.assetNumber = assetNumber;
            errorMsg.assetError = "Please enter Valid Asset #";
            setIsAsserNumberValid(false)
            setAddToCart(false)
        } else if (assetNumber?.length > 15) {
            errorMsg.assetNumber = assetNumber;
            errorMsg.assetError = "Please enter Asset less then 15 digits";
        } else if (errorMsg?.assetError?.length == 0 && !addToCart) {
            errorMsg.assetNumber = assetNumber;
            errorMsg.assetError = "Click 'Get Asset Info' button to validate";
        }
        else {
            errorMsg.assetError = ""
            setIsAsserNumberValid(true)
        }
        let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : [];
        assetDetailListTemp.forEach((assetItem: any) => {
            if (assetItem.assetIndex === order.assetIndex) {
                assetItem.assetNumber = assetNumber
                assetItem.assetError = errorMsg.assetError;
            }
        });
        setOrder(assetDetailListTemp)
    }

    const handleChanges = (e: any, item: any) => {

        dispatch(RequisitionAction.setIsChangesOccured(true));
        let nameVal = '';
        let val = item;
        if (e?.target?.name) {
            nameVal = e.target.name
        }

        if ((nameVal === "asset") && val) {
            const regEx = /^\d{0,15}(\.\d{1,4})?$/;
            const valArr = val.split('.')
            const checkNumber = regEx.test(val);
            if (!checkNumber || valArr.length > 1) {
                return;
            }
        }

        if (orderDetails?.requestType?.label && (orderDetails?.requestType?.label !== CONSTANTS?.REQUISITION)) {
            setIsAssetBtnClicked(false)
            setAddToCart(false)
            setIsAsserNumberValid(false)
            validateAsset(val)
            setChangedIndex(order?.assetIndex)
        } else {
            let reasonListTemp = reasonList?.length > 0 ? [...reasonList] : [];
            for (let i = 0; i < reasonListTemp?.length; i++) {
                if (reasonListTemp[i]?.reasonIndex === order?.reasonIndex) {
                    reasonListTemp[i].asset = val;

                    reasonListTemp[i].unitNumber = "";
                    reasonListTemp[i].description = "";
                    reasonListTemp[i].modelYear = "";
                    reasonListTemp[i].netBookedValue = "";
                    reasonListTemp[i].replacementAssetDisposalDate = "";
                    reasonListTemp[i].isValidAsset = false;
                    reasonListTemp[i].assetError = "";

                    let responseReason = RequisitionValidation.ValidateReason({ ...reasonListTemp[i] });
                    reasonListTemp[i] = responseReason;
                    dispatch(RequisitionAction.setIReason(reasonListTemp))
                }
            }

        }
    }


    useEffect(() => {
        if (orderDetails?.requestType?.label && (orderDetails?.requestType?.label !== CONSTANTS?.REQUISITION)) {
            let assetDetailListTemp = assetDetailList?.length > 0 ? [...assetDetailList] : [];
            assetDetailListTemp.forEach(assetItem => {
                if (assetItem?.assetNumber && assetValidationError.assetError && assetItem?.assetNumber == assetValidationError?.assetNumber?.toString() && assetItem?.assetIndex == changedIndex) {
                    (!assetValidationError?.assetError?.length && isAssetBtnClicked) ? setIsAsserNumberValid(true) : setIsAsserNumberValid(false)
                    assetItem.assetError = assetValidationError.assetError;
                    assetItem.unitNumber = "";
                    assetItem.modelYear = "";
                    assetItem.color = "";
                    assetItem.description = "";
                    assetItem.serialNumber = "";
                    assetItem.licensePlateNumber = "";
                    assetItem.monthlyAmount = "";
                    assetItem.monthRemaining = "";
                    assetItem.equipmentClassDesc = "";
                    assetItem.eqStatusDesc = "";
                    assetItem.netBookedValue = "";
                    assetItem.glCategory = "";
                    assetItem.isOdometerRequired = "";
                    assetItem.model = '';
                    assetItem.costCenterNo = '';
                    assetItem.manufacturerName = '';
                    assetItem.dateDisposed = '';
                    return
                }
            });
            setOrder(assetDetailListTemp);
        } else if (type == CONSTANTS?.REQUISITION) {

            let reasonListTemp = reasonList?.length > 0 ? [...reasonList] : [];
            for (let i = 0; i < reasonListTemp?.length; i++) {
                if (reasonListTemp[i]?.reasonIndex === assetChangeReason?.reasonIndex) {
                    if (reasonListTemp[i]?.asset == assetValidationError?.assetNumber) {
                        reasonListTemp[i].asset = assetValidationError?.assetNumber;

                        reasonListTemp[i].unitNumber = "";
                        reasonListTemp[i].description = "";
                        reasonListTemp[i].modelYear = "";
                        reasonListTemp[i].netBookedValue = "";
                        reasonListTemp[i].replacementAssetDisposalDate = "";
                        reasonListTemp[i].isValidAsset = false;
                        reasonListTemp[i].assetError = assetValidationError?.assetError;
                        setAssetChangeReason([])
                        dispatch(RequisitionAction.setIReason(reasonListTemp))
                    }
                }
            }

        } else {
            setAssetNumbererror("")
        }
    }, [assetValidationError, assetDetails])


    return (<>
        <AssetNumber
            assetNumberError={assetNumberError}
            handleKeyPress={handleKeyPress}
            order={order}
            handleAssetBtn={handleAssetBtn}
            handleChanges={handleChanges}
            type={type}
            inputRef={inputRef}
            AssetType={AssetType}
        />
    </>)
}

export default AssetNumberContainer;
